import { ExpressionSpecification, LayerSpecification } from "mapbox-gl";
import { useEffect } from "react";

import GaiaMapStyle from "~/modules/map/components/GaiaMapStyle";
import { useGaiaMap } from "~/modules/map/hooks/useGaiaMap";
import { loadStripeFillPattern } from "~/modules/map/util/imageLoaders";
import { MAP_LEGEND_ICON_SIZE } from "~/modules/project/screens/ProjectDeliverablesScreen/components/ProjectDeliverablesMapLegend";

import { LAYER_DEFAULTS } from "./layerDefaults";

const FILL_OPACITY = 0.1;
const OUTLINE_WIDTH = 2;

type Props = {
    id: string;
    source: string;
    color: ExpressionSpecification | string;
    pattern: ExpressionSpecification | string;
    colors: string[];
    filter?: ExpressionSpecification;
};

export function GaiaMapStyleAreaFillWithDashedLines({ id, source, color, pattern, colors, filter }: Props) {
    const { map } = useGaiaMap();

    useEffect(() => {
        if (!map) return;
        colors.forEach(colorToLoad => {
            loadStripeFillPattern(map, colorToLoad);
        });
    }, [map, colors]);

    const layers: LayerSpecification[] = [
        {
            id: `${id}_wash`,
            source,
            type: "fill",
            slot: LAYER_DEFAULTS.slot,
            ...(filter && { filter }),
            paint: {
                "fill-color": color,
                "fill-opacity": FILL_OPACITY,
            },
        },
        {
            id: `${id}_stripes`,
            source,
            type: "fill",
            slot: LAYER_DEFAULTS.slot,
            ...(filter && { filter }),
            paint: {
                "fill-pattern": pattern,
            },
        },
        {
            id: `${id}_outline`,
            source,
            type: "line",
            slot: LAYER_DEFAULTS.slot,
            ...(filter && { filter }),
            paint: {
                "line-color": color,
                "line-width": OUTLINE_WIDTH,
            },
        },
    ];

    return <GaiaMapStyle layers={layers} />;
}

export function GaiaMapStyleAreaFillWithDashedLinesLegendIcon() {
    return (
        <svg width={MAP_LEGEND_ICON_SIZE} height={MAP_LEGEND_ICON_SIZE} viewBox="0 0 16 16" aria-hidden="true">
            <line x1="1" y1="1" x2="15" y2="1" stroke="#000" strokeWidth={1} />
            <line x1="1" y1="5" x2="15" y2="5" stroke="#000" strokeWidth={1} />
            <line x1="1" y1="9" x2="15" y2="9" stroke="#000" strokeWidth={1} />
            <line x1="1" y1="13" x2="15" y2="13" stroke="#000" strokeWidth={1} />
            <line x1="1" y1="17" x2="15" y2="17" stroke="#000" strokeWidth={1} />
        </svg>
    );
}
